module.exports = __webpack_public_path__ + "media/images/sif_logo-863276f341ae9afa4a90579c2468259f.png";